import React, { useCallback } from 'react';

import { WebUI } from '../../_utils/ui';
import translate from '../../_utils/tools/translate';

import fireTrackingEvent from './events/fire-tracking-event';
import ProgressButton from '../../_utils/progress-button';
import sendToGoogleAnalytics from '../../_libs/analytics/builder-send-to-google-analytics';

const buttonText = `Add to ${translate('Cart')}`;

const AddToCartControls = ({ basketUrl, enabled, onAddToCart }) => {
  const handleAddToCart = useCallback(
    e => {
      e.preventDefault();

      if (enabled) {
        onAddToCart(() => {
          sendToGoogleAnalytics('Add-to-cart', 'checkout');
          fireTrackingEvent(WebUI.PHOTO_EVENT_ADD_TO_CART);
          location.href = basketUrl;
        });
      }
    },
    [enabled, onAddToCart, basketUrl]
  );

  return (
    <ProgressButton
      aria-label={buttonText}
      className="btn btn-primary btn-add-to-cart"
      data-test="add-to-cart"
      disabled={!enabled}
      href={basketUrl}
      onClick={handleAddToCart}>
      {buttonText}
    </ProgressButton>
  );
};

export default AddToCartControls;
